import React, {useEffect} from 'react';
import PropTypes from 'prop-types';

const TgWistiaPlayer = ({videoId, wrapper}) => {

  useEffect(() => {
	if (window.analytics) {
	  let a = new TgAnalytics;

	  window.analytics.track(`Wistia Loaded`, {
		analytics_tag: wrapper,
		...a.pageData,
	  });
	}
  }, []);

	const frameStyle = {
		borderRadius: 10,
		border: "none"
	};

	useEffect(() => {
	  window._wq = window._wq || [];
	  _wq.push({ id: videoId, onReady: function(video) {
		  video.bind("cancelfullscreen", function() {
			video.videoWidth(780, { constrain: true });
		  })

		}});
	}, [])

  return (
	  <div id={`${wrapper}`} className="max-w-xs xs:max-w-md sm:max-w-lg md:max-w-2xl lg:max-w-6xl">
		  <iframe
			  data-video-id={videoId}
			  src={`//fast.wistia.net/embed/iframe/${videoId}?videoFoam=true`}
			  scrolling="no"
			  className="wistia_embed"
			  name="wistia_embed"
			  width={780}
			  height={530}
			  allowFullScreen
			  mozallowfullscreen=""
			  webkitallowfullscreen=""
			  oallowfullscreen=""
			  msallowfullscreen=""
			  style={frameStyle}
		  />
	  </div>
		  )

}

TgWistiaPlayer.propTypes = {
  videoId: PropTypes.string,
  wrapper: PropTypes.string,
}

export default TgWistiaPlayer


// WEBPACK FOOTER //
// ./app/javascript/bundles/ui/TgWistiaPlayer/TgWistiaPlayer.jsx